'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isLastMonth.js
// module id = 232
// module chunks = 1